import Announcer from './Announcer';

export default Announcer;
